import styles from './SafeAreaView.module.css'

export interface SafeAreaViewProps {
  children: JSX.Element
}

export default function SafeAreaView({ children }: SafeAreaViewProps) {
  return <div className={styles.shell}>{children}</div>
}
